angular.module('rjmNg.controllers').controller 'utilitiesCtrl', [
  "$scope"
  "$routeParams"
  "$window"
  "$location"
  "Charts"
  "Figures"
  "dashboardService"
  "$modal"
  "$url"
  "app"
  "Trend"
  "DashboardItem"
  "ConnectionMeta"
  "appRoute"
  "logger"
  "MOBILE_WIDTH"
  "rjpopoverGroupNames"
  "DashboardDividers"
  "dashboardConstants"
  (
    $scope
    $routeParams
    $window
    $location
    Charts
    Figures
    dashboardService
    $modal
    $url
    app
    Trend
    DashboardItem
    ConnectionMeta
    appRoute
    logger
    MOBILE_WIDTH
    rjpopoverGroupNames
    DashboardDividers
    dashboardConstants
  ) ->

    $scope.RJPOPOVER_GROUP_NAME = rjpopoverGroupNames.DASHBOARDS
    $scope.DIVIDER_TYPES = dashboardConstants.DIVIDER_TYPES

    $scope.dashboard = dashboardService.dashboard
    $scope.chartBuilderIsOpen = false

    $scope.addChartDropdown =
      isAddChartOpen: false
      chartListSearchTerm: ""

    $scope.isDashboardView = ->
      return ($routeParams.dashId? or $location.path() is appRoute("/")) and not $scope.chartBuilderIsOpen

    $scope.isMobile = ->
      return $window.innerWidth <= MOBILE_WIDTH

    $scope.$on 'openChartBuilder', () ->
      $scope.chartBuilderIsOpen = true

    $scope.$on 'closeChartBuilder', () ->
      $scope.chartBuilderIsOpen = false

    $scope.$on 'dashboardReady', () ->
      $scope.chartBuilderIsOpen = false
      $scope.dashboard = dashboardService.dashboard
      $scope.canEditDashboard = dashboardService.canEditDashboard() and not app.isReadOnlyUser()
      $scope.showBulkEdit = $scope.canEditDashboard
      $scope.areDashboardDividersAllowed = app.areDashboardDividersAllowed()

      $scope.permissionsTitle = switch
        when app.isReadOnlyUser() then 'Read Only'
        when dashboardService.getDashboardOwnerId() is app.getUserId() then ''
        when not dashboardService.canEditDashboard() then 'View Only'
        else ''

    # If we finished browsing and have no dashboards, prompt them to create one
    $scope.$on 'doneBrowsingDashboards', () ->
      if app.getDashboards().length < 1
        $scope.createNewDashboard(true)

    $scope.$on 'addNewReportClicked', () ->
      $scope.addReportDropdown = angular.element('#js-add-report-trigger').parent('.rj-dropdown')
      $scope.addReportDropdown.addClass('open')
      $scope.addChartDropdownClicked()

    $scope.clients = app.getClients()
    $scope.client = app.getClient()

    $scope.metrics = Trend.getMetalist(clientId: app.getClientId())

    ConnectionMeta(app.getClientId()).gaConnections().then((connections) ->
      $scope.gaConnections = connections
    )

    $scope.addDashboardItemFromNavBar = (event, chart) ->
      event?.preventDefault()
      itemSettings = 
        dashId: $routeParams.dashId
      if(app.hasFeatureFlag('RJQL_SERVICE_CLIENT'))
        itemSettings.figureId = chart.id
      else
        itemSettings.figureId = chart.figureId
        itemSettings.chartId = chart.chartId

      DashboardItem.save
        clientId: app.getClientId()
      , itemSettings
      , (dashboardItem) =>
        dashboardService.dashboardItemAdded dashboardItem

    $scope.addDividerFromNavBar = (type) ->
      if $scope.areDashboardDividersAllowed
        DashboardDividers.addDividerToDashboard(
          $routeParams.dashId
          app.getClientId()
          type
        )

    # Open the bulk edit charts modal
    $scope.bulkEditModal = ->
      $modalScope = $scope.$new()
      logger.log('Bulk Edit Reports Modal Usage', 'Open', 1, 'edit')
      modal = $modal
        template: "modal.bulkEdit.html"
        show: true
        backdrop: 'static'
        scope: $modalScope
        persist: false
        modalClass: 'largeModal'

    $scope.exportDashboard = () ->
      $window.open($url("/client/" + app.getClientId() + "/dashboard/" + $scope.dashboard.id + "/exportxlsx/"), "_blank")
      return

    $scope.createNewDashboard = (force) ->
      $modalScope = $scope.$new()
      $modalScope.force = if force? then true else false
      $modalScope.dashboardGroups = _.filter(_.unique(app.getDashboards().map((dashboard) ->
        dashboard.group
      )), (group) ->
        group isnt 'UNGROUPED'
      )

      # This user has no dashboards, prompt them to make one
      modal = $modal
        template: "modal.createDash.html"
        show: true
        backdrop: 'static'
        scope: $modalScope
        keyboard: if force? or app.isReadOnlyUser() then false else true
        modalClass: "newDashboardModal"

    $scope.hideShare = app.isDemoUser() && !app.isSupportUserSession()

    $scope.browseSharedDashboards = (force, buttonType=null) ->
      $modalScope = $scope.$new()
      $modalScope.force = force
      $modalScope.buttonType = buttonType
      # This user has no dashboards, show them some they can add
      modal = $modal
        modalClass: 'shared-dash'
        template: "modal.browseSharedDash.html"
        show: true
        backdrop: 'static'
        scope: $modalScope
        keyboard: true

    $scope.canBrowseDashboards = () ->
      app.hasFeatureFlag('DASHBOARD_DISCOVERY') and not app.isReadOnlyUser() and not app.isAumEnabled()  

    $scope.renameDashboardModal = ->
      $modalScope = $scope.$new()
      $modalScope.name = $scope.dashboard?.name
      modal = $modal(
        template: "modal.renameDash.html"
        show: true
        backdrop: 'static'
        scope: $modalScope
      )

    $scope.defaultDashboardModal = ->
      $modalScope = $scope.$new()
      modal = $modal(
        template: "modal.defaultDash.html"
        show: true
        backdrop: 'static'
        scope: $modalScope
      )

    $scope.deleteDashboardModal = ->
      $modalScope = $scope.$new()
      modal = $modal(
        template: "modal.deleteDash.html"
        show: true
        backdrop: 'static'
        scope: $modalScope
      )

    $scope.dashCloneModal = () ->
      $modalScope = $scope.$new()
      $modalScope.name = $scope.dashboard.name
      $modalScope.id = $scope.dashboard.id
      modal = $modal(
        template: "modal.dashClone.html",
        show: true,
        backdrop: 'static'
        keyboard: false
        scope: $modalScope
      )

    $scope.unshareDashboard = () ->
      $modalScope = $scope.$new()
      modal = $modal(
        template: "modal.unshareDash.html"
        show: true
        backdrop: 'static'
        scope: $modalScope
      )

    $scope.addChartDropdownClicked = () ->
      $scope.addChartDropdown.isAddChartOpen = !$scope.addChartDropdown.isAddChartOpen
      $scope.addChartDropdown.chartListSearchTerm = ""

    $scope.getAddFigureUrl = () ->
      dashboardService.getAddFigureUrl()

    _canSeeDashboards = () ->
      app.getClient().isImplemented is 1 or app.isSupportUserSession()

    $scope.noDashboardCheck = () ->
      if ($routeParams.dashId? or $location.path().match("dashapp/?$")) and app.getDashboards().length is 0 and _canSeeDashboards()
        if $scope.canBrowseDashboards()
          $scope.browseSharedDashboards(true)
        else
          $scope.createNewDashboard(true)

    $scope.noDashboardCheck()

    _init = () ->
      if(app.hasFeatureFlag('RJQL_SERVICE_CLIENT'))
        Figures.getAllFigures().then (data) ->
          $scope.chartModels = data
      else
        Charts.getCharts().then (data) ->
          $scope.chartModels = data
      null

    _init()
]
